import {lowerCaseKeys, makeAppTopMod} from "../../utilities/utilityFunctions";
import {login} from "src/services/permissions/APIServices";
import store from "src/store";
import {appSettingModel} from "src/datamodels/foundation";
import {updateUser} from "src/actions/permissionsActions";
import {updateAppSettings} from "src/actions/foundationActions";

export const logUserOut = () => {
    store.dispatch({type:"LOGOUT_USER"});
};

export const listenForEnter = (e,func) => {
    func = func ? func : logUserIn;
    if (e.charCode === 13) {
        func(e);
    }
};

const processLogin = (evt) => {
    let person=lowerCaseKeys(evt.data);
    if(!person || !person.personuuid || person.personuuid===''){
        store.dispatch(updateAppSettings({userMessage:"Sorry! We did not find that account."}));
    }
    else {
        person.isLoggedIn=true;
        store.dispatch(updateUser(Object.assign({},person)));
        makeAppTopMod(appSettingModel().defaultLoggedInModule);
    }
};

const loginfail = (evt) => {
    store.dispatch(updateAppSettings({userMessage:"Sorry! We had a problem logging in!"}));
};

export const logUserIn = (un,pass) => {
    un=un? un : document.querySelector("#emailInput").value;
    pass = pass ? pass : document.querySelector("#password").value;
    //eslint-disable-next-line
    login({un:un,pwd:pass,site:self.location.hostname},
        (evt)=>processLogin(evt),
        (evt)=>loginfail(evt));
};

export const obtainUser = () => {
    let newStore = store.getState();
    return newStore.user ? newStore.user.token : '';
};
